import { POSTHOG_TRACKING_EVENTS, PosthogTrackingSource } from '../constants';
import { CaptureTrackingEvent } from './types';

export const createThemeEvents = (
  captureTrackingEvent: CaptureTrackingEvent
) => {
  const trackThemeOpen = (source: PosthogTrackingSource, themeIds: string[]) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.THEME_OPEN,
      properties: {
        source,
        themeIds,
      },
    });

  const trackThemeOverviewDrawerOpen = (
    source: PosthogTrackingSource,
    themeIds: string[]
  ) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.THEME_OVERVIEW_DRAWER_OPEN,
      properties: { source, themeIds },
    });

  const trackThemeToThemeDrawerOpen = (
    source: PosthogTrackingSource,
    themeIds: string[]
  ) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.THEME_TO_THEME_DRAWER_OPEN,
      properties: { source, themeIds },
    });

  const trackThemePerformanceWidgetTabSelected = (
    source: PosthogTrackingSource,
    type: string,
    themeIds: string[]
  ) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.THEME_PERFORMANCE_WIDGET_TAB_SELECTED,
      properties: { source, type, themeIds },
    });

  const trackThemeEarningsTabSelected = (
    source: PosthogTrackingSource,
    type: string,
    themeIds: string[]
  ) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.THEME_EARNINGS_TAB_SELECTED,
      properties: { source, type, themeIds },
    });

  const trackThemeEarningsPeriodSelected = (
    source: PosthogTrackingSource,
    type: string
  ) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.THEME_EARNINGS_PERIOD_SELECTED,
      properties: { source, type },
    });

  const trackThemeEarningsFilterSelected = (
    source: PosthogTrackingSource,
    type: string
  ) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.THEME_EARNINGS_FILTER_SELECTED,
      properties: { source, type },
    });

  const trackThemeEarningsRowClicked = (
    source: PosthogTrackingSource,
    entities: string[],
    type: string
  ) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.THEME_EARNINGS_ROW_CLICKED,
      properties: { source, entities, type },
    });

  return {
    trackThemeOpen,
    trackThemeOverviewDrawerOpen,
    trackThemeToThemeDrawerOpen,
    trackThemePerformanceWidgetTabSelected,
    trackThemeEarningsTabSelected,
    trackThemeEarningsPeriodSelected,
    trackThemeEarningsFilterSelected,
    trackThemeEarningsRowClicked,
  };
};
